import React from "react";

import ButtonPlaceholder from "@/components/ButtonSkeleton";
import Placeholder, { Rect } from "@/components/Skeleton";

const SearchResultsPlaceholder: React.FC = () => (
  <div className="container mb-section">
    <Placeholder width="150" height="28" className="mb-sm">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <Placeholder width="250" height="18" className="mb-5">
      <Rect width="100%" height="100%" />
    </Placeholder>
    <div className="flex flex-col md:flex-row gap-lg">
      {new Array(4).fill(null).map((_, i) => (
        <Placeholder
          width="100%"
          height="100%"
          key={`generic-card-placeholder-${i}`}
          className="rounded shadow-low min-h-[212px] md:min-h-[400px]"
        >
          <Rect width="100%" height="100%" />
        </Placeholder>
      ))}
    </div>
    <ButtonPlaceholder height="36" className="mt-5 md:max-w-[322px]" />
  </div>
);

export default SearchResultsPlaceholder;
